export default __webpack_public_path__ + "static/logo-android-white-f916da75ebc1929c054ce5a88766de35.svg";